<template>
  <div id="forget">
    <div class="header">
      <div>
        <a title="海星云修改密码" class="fl logo">
          <img
            draggable="false"
            src="../../static/images/logo/logo1.png"
            alt="海星云修改密码"
          />
        </a>
        <a class="fr Return"
          ><span
            @mouseenter="Returnasdf"
            @mouseleave="Returna"
            @click="Returngo"
            ><img :src="Return" alt="返回首页" />返回</span
          ></a
        >
      </div>
      <p>海星云云游戏平台</p>
    </div>
    <div class="signIn">
      <!-- 手机号 -->
      <div class="from">
        <div class="input">
          <p class="fl">手机号码</p>
          <div>
            <input
              type="text"
              class="inputm fl"
              :class="[phone == false ? 'inputm' : 'inputh']"
              placeholder="请输入手机号码"
              @blur="phonea"
              v-model="shuru.phone"
            />
            <span>{{ cuowuspan.phone }}</span>
          </div>
        </div>
        <!-- 滑块 -->
        <div class="input">
          <p class="fl"></p>
          <div id="your-dom-id" class="nc-container fl"></div>
        </div>
        <!-- 验证码 -->
        <div class="input">
          <p class="fl">验证码</p>
          <div>
            <input
              type="text"
              class="inputm fl"
              style="width:120px"
              :class="[Verification == false ? 'inputm' : 'inputh']"
              placeholder="请输入六位验证码"
              @blur="Verificationa"
              v-model="shuru.Verification"
            />
            <button
              style="
                                border:1px solid #dfdfdf;
                                width:100px;
                                height:40px;
                                background:#356DED;
                                color:#dfdfdf;
                                border-radius:5px;
                            "
              :disabled="disabled"
              @click="send"
            >
              {{ sends }}
            </button>
            <span>{{ cuowuspan.Verification }}</span>
          </div>
        </div>
        <!-- 密码 -->
        <div class="input">
          <p class="fl">新密码</p>
          <div>
            <input
              type="password"
              class="inputm fl"
              :class="[pass == false ? 'inputm' : 'inputh']"
              placeholder="请输入数字字母8~25位新密码"
              @blur="passa"
              v-model="shuru.pass"
              autocomplete="new-password"
            />
            <span>{{ cuowuspan.pass }}</span>
          </div>
        </div>
        <!-- 二次密码 -->
        <div class="input">
          <p class="fl">确认新密码</p>
          <div>
            <input
              type="password"
              class="inputm fl"
              :class="[password == false ? 'inputm' : 'inputh']"
              placeholder="请再次确认新密码"
              @blur="passworda"
              v-model="shuru.password"
              @keydown="security"
              autocomplete="new-password"
            />
            <span>{{ cuowuspan.password }}</span>
          </div>
        </div>
        <div class="Registerbtn">
          <a
            :class="[checked == true ? 'Registerbtnl' : 'Registerbtnm']"
            @click="forget"
          >
            确认修改
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title:'海星云忘记密码，云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:'海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content:'海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      // 滑块参数
      nc_token: '',
      csessionid: '',
      sig: '',
      // 发送验证按按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,

      checked: false,
      Return: './../../static/images/icon/Return.png',
      // 输入的数据
      shuru: {
        phone: '',
        Verification: '',
        pass: '',
        password: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        Verification: '',
        pass: '',
        password: ''
      },
      // 标识符
      phone: false,
      Verification: false,
      pass: false,
      password: false
    }
  },
  methods: {
    send () {
      this.nc_token = this.$cookieStore.getCookie('nc_token')
      this.csessionid = this.$cookieStore.getCookie('csessionid')
      this.sig = this.$cookieStore.getCookie('sig')
      if (this.shuru.phone == '') {
        this.cuowuspan.phone = '请填写手机号'
        this.phone = true
        return false
      } else if (this.nc_token == '' || this.csessionid == '' || this.sig == '') {
        this.$message.error('请滑动滑块进行人机验证')
        return false
      } else {
        this.http.yzpho(this.shuru.phone).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'false') {
              this.cuowuspan.phone = '该手机号没有注册，请注册！'
              this.phone = true
              return false
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
            return false
          }
          this.http.send(this.shuru.phone, this.nc_token, this.csessionid, this.sig).then(res => {
            if (res.data.code == 200) {
              if (res.data.message == 'ok') {
                this.$message({
                  message: '验证码已发送到您的手机，请注意查看',
                  type: 'success'
                })
                var that = this
                var resend = setInterval(function () {
                  that.sendstime--
                  if (that.sendstime > 0) {
                    that.sends = that.sendstime + 's后重新获取'
                    that.disabled = true
                  } else {
                    clearInterval(resend)
                    that.sends = '获取验证码'
                    that.sendstime = 60
                    that.disabled = false
                  }
                }, 1000)
              }
            } else if (res.data.code == 400) {
              if (res.data.message == 'failed,unable to get data') {
                this.$message.error('不能获取到数据')
              } else if (res.data.message == 'failed,user phone invalid') {
                this.$message.error('手机号无效')
              } else if (res.data.message == 'failed,afs authenticate invalid') {
                this.$message.error('滑块验证失败')
              }
            } else if (res.data.code == 500) {
              if (res.data.message == 'failed,please retry!') {
                this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
              }
            }
          })
        })
      }
    },
    security () {
      if (this.shuru.phone == '' || this.shuru.Verification == '' || this.shuru.pass == '') {
        return false
      } else if (this.phone == true || this.Verification == true || this.pass == true) {
        return false
      } else if (this.shuru.password.length >= 7) {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    forget () {
      if (this.shuru.phone == '' || this.shuru.Verification == '' || this.shuru.pass == '' || this.shuru.password == '') {
        return false
      } else if (this.phone == true || this.Verification == true || this.pass == true || this.password == true) {
        return false
      } else if (this.checked == true) {
        this.http.xgpass(this.shuru.phone, this.shuru.Verification, this.shuru.pass)
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.message == 'ok') {
                this.$message({
                  message: '修改成功，快去登录吧！',
                  type: 'success'
                })
                this.$router.push('./SignIn')
              }
            }
          }).catch(err => {
            this.$message.error('修改密码失败')
          })
      }
    },
    Returngo () {
      this.$router.push('./SignIn')
    },
    Returnasdf () {
      this.Return = './../../static/images/icon/Return1.png'
    },
    Returna () {
      this.Return = './../../static/images/icon/Return.png'
    },
    phonea () {
      if (this.shuru.phone == '') {
        this.phone = true
        this.cuowuspan.phone = '请填写手机号'
        return false
      } else if (this.shuru.phone) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phone)) {
          this.phone = false
          this.cuowuspan.phone = ''
        } else {
          this.phone = true
          this.cuowuspan.phone = '手机号格式有误'
          return false
        }
      }
    },
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        this.Verification = true
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.Verification = false
          this.cuowuspan.Verification = ''
        } else {
          this.Verification = true
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    },
    passa () {
      if (this.shuru.pass == '') {
        this.cuowuspan.pass = '请输入密码'
        this.pass = true
        return false
      } else if (this.shuru.pass) {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
        if (reg.test(this.shuru.pass)) {
          this.cuowuspan.pass = ''
          this.pass = false
        } else {
          this.cuowuspan.pass = '密码格式有误'
          this.pass = true
          return false
        }
      }
    },
    passworda () {
      if (this.shuru.password == '') {
        this.cuowuspan.password = '请再次输入密码'
        this.password = true
        return false
      } else if (this.shuru.password == this.shuru.pass) {
        this.cuowuspan.password = ''
        this.password = false
      } else {
        this.cuowuspan.password = '两次密码输入不一致'
        this.password = true
        return false
      }
    },
    // 滑块
    init () {
      var that = this
      var nc_token = ['FFFF0N0000000000805E', (new Date()).getTime(), Math.random()].join(':')
      var NC_Opt =
            {
              renderTo: '#your-dom-id',
              appkey: 'FFFF0N0000000000805E',
              scene: that.sceneaa,
              token: nc_token,
              customWidth: 300,
              trans: {'key1': 'code0'},
              elementID: ['usernameID'],
              is_Opt: 0,
              language: 'cn',
              isEnabled: true,
              timeout: 3000,
              times: 5,
              apimap: {
              },
              callback: function (data) {
                that.$cookieStore.setCookie('nc_token', nc_token, 600)
                that.$cookieStore.setCookie('csessionid', data.csessionid, 600)
                that.$cookieStore.setCookie('sig', data.sig, 600)
              }
            }
      var nc = new noCaptcha(NC_Opt)
      nc.upLang('cn', {
        _startTEXT: '请拖动滑块进行验证',
        _yesTEXT: '验证通过,<a href="javascript:__nc.reset()">点击刷新</a>',
        _error300: '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
      })
    }
  },
  created: function () {
    // 判断浏览器的宽度
    if (document.body.clientWidth < 750) {
      this.sceneaa = String('nc_other_h5')
    } else {
      this.sceneaa = String('nc_other')
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.$cookieStore.delCookie('nc_token')
    this.$cookieStore.delCookie('csessionid')
    this.$cookieStore.delCookie('sig')
  }
}
</script>
<style scoped>
#forget {
  height: 100%;
  background: #f2f2f2;
  padding-bottom: 100px;
}
#forget .header {
  width: 100%;
  height: 60px;
  background: #fff;
  margin-bottom: 60px;
}

#forget .header .logo {
  display: block;
  width: 8rem;
  height: 60px;
}
#forget .header .logo img {
  width: 100%;
  height: auto;
  margin-top: 15px;
}
#forget .header .Return {
  width: 90px;
  font-size: 16px;
  height: 32px;
  line-height: 32px;
  margin-top: 13px;
  font-weight: bold;
}
#forget .header .Return:hover {
  color: #295ca4;
}
#forget .header .Return img {
  width: 32px;
  height: 32px;
  vertical-align: bottom;
  margin-right: 5px;
}
#forget .header p {
  width: 100%;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  font-size: 1.625rem;
  margin-left: -8rem;
}
.signIn {
  width: 37.5rem;
  position: relative;
  margin: 0 auto;
  background: #f2f2f2;
  border: 10px solid #fff;
  padding: 6.25rem;
  border-radius: 10px;
}
.inputm {
  border: 2px solid #dfdfdf;
}
.inputh {
  border: 2px solid #e60012;
  background: #ffe4e4;
}
.signIn .input {
  height: 55px;
  margin-bottom: 20px;
}
.signIn .input div {
  position: relative;
}
.signIn .input .fangchenmi {
  width: 18.75rem;
  position: absolute;
  top: -14px;
  left: 16.875rem;
  font-size: 0.75rem;
  line-height: 12px;
  z-index: 10;
}
.signIn .input .fangchenmi .why {
  display: block;
  padding: 0.625rem;
  width: 17.5rem;
  height: 80px;
  border: 1px solid #dfdfdf;
  position: absolute;
  top: 14px;
  left: 0;
  color: #3d3d3d;
  background: #fff;
  line-height: 20px;
}

.signIn .input p {
  width: 16.75rem;
  line-height: 55px;
  height: 55px;
  font-size: 0.875rem;
  font-weight: bold;
}
.signIn .input input {
  display: block;
  padding: 6px 0.875rem;
  width: 18.75rem;
  height: 24px;
  border-radius: 5px;
}
.signIn .input span {
  position: absolute;
  top: 40px;
  left: 16.75rem;
  font-size: 0.75rem;
  color: #e60012;
}
.Registerbtnm {
  background: #b1b1b1;
}
.Registerbtnl {
  background: #295ca4;
}
.signIn .Registerbtn a {
  width: 6.875rem;
  height: 18px;
  display: block;
  padding: 9px 1.25rem;
  border: 1px solid #b1b1b1;
  border-radius: 19px;
  color: #fff;
  text-align: center;
  margin: 30px auto;
}
@media screen and (max-width: 750px) {
  #Register {
    width: 100%;
  }
  .signIn {
    width: 300px;
    padding: 10px;
  }
  #forget .header p {
    display: none;
  }
  #Register .header .logo {
    display: block;
    width: 8rem;
    height: 60px;
  }
  #Register .header p {
    display: none;
  }
  #Register .header .Return {
    width: 5.625rem;
    font-size: 1rem;
    height: 2rem;
    line-height: 2rem;
    margin-top: 17px;
    font-weight: bold;
  }
  #Register .header .Return span {
    display: block;
    height: 2rem;
  }
  #Register .header .Return:hover {
    color: #295ca4;
  }
  #Register .header .Return img {
    width: 2rem;
    height: 2rem;
    vertical-align: bottom;
    margin-right: 5px;
  }
  .signIn .input {
    height: 95px;
  }
  .signIn .input input {
    width: 275px;
  }
  .signIn .input span {
    position: absolute;
    top: 95px;
    left: 0;
    font-size: 0.75rem;
    color: #e60012;
  }
  .from {
    width: 300px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Forget.vue